import { render, staticRenderFns } from "./Privacy-Policy.vue?vue&type=template&id=d191041a&"
import script from "./Privacy-Policy.vue?vue&type=script&lang=js&"
export * from "./Privacy-Policy.vue?vue&type=script&lang=js&"
import style0 from "./Privacy-Policy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports